import { gql } from '@graphql/__generated__';

// How many times the profile was shown on RealAdvisor (directory, valuation
// results, price pages, profile page…). Agent: its own agent_impression events
// within its agency; agency: the agency's agency_impression events.
export const CLAIM_PROFILE_IMPRESSIONS = gql(/* GraphQL */ `
  query ClaimProfileImpressions(
    $teamId: uuid!
    $userId: uuid
    $hostname: String!
    $startDate: String!
    $endDate: String!
    $eventNames: [String!]!
  ) {
    impressions_total(
      agency_uuid: $teamId
      agent_uuid: $userId
      date_range_start: $startDate
      date_range_end: $endDate
      hostname: $hostname
      event_names: $eventNames
    ) {
      count
    }
  }
`);
